import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"plus\"><path d=\"M496 192H320V16c0-8.832-7.152-16-16-16h-96c-8.848 0-16 7.168-16 16v176H16c-8.848 0-16 7.168-16 16v96c0 8.848 7.152 16 16 16h176v176c0 8.848 7.152 16 16 16h96c8.848 0 16-7.152 16-16V320h176c8.848 0 16-7.152 16-16v-96c0-8.832-7.152-16-16-16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/plus.svg
// module id = RtHv
// module chunks = 1